import React, { Fragment } from "react";
import * as d3 from "d3";
import PropTypes from "prop-types";

const TreeMap = ({ width, height, data }) => {
  let color = d3.scale
    .ordinal()
    .range([
      "#3c4694",
      "#0048ba",
      "#6da9d2",
      "#00626f",
      "#0077b3",
      "#246bce",
      "#87cded",
      "#94c0cc",
      "#003377",
      "#779ecb",
      "#000080",
      "#0076cc",
      "#779ecb",
      "#346cb0",
      "#b1c6c7",
    ]);

  const treemap = d3.layout
    .treemap()
    .padding(0)
    .size([width, height])
    .value((d) => d.size)
    .nodes(data);

  const stroke = {
    stroke: "#fff",
    strokeWidth: "3px",
  };

  const getShortSymbol = (str) => {
    if (str.length < 5) return str;
    return str
      .replace(/\b(\w{1,2})(\w+\s?|\s)/g, "$1 ")
      .toUpperCase()
      .slice(0, -1);
  };

  const cell = treemap.map((d, i) => {
    return (
      <g className="cell" key={i} transform={`translate(${d.x},${d.y})`}>
        <rect
          style={stroke}
          width={d.dx}
          height={d.dy}
          fill={d.children ? null : color(d.name)}
        />
        <text
          x={d.dx / 2}
          y={d.dy / 2}
          dy={"0px"}
          textAnchor={"middle"}
          fontWeight="bold"
          fontSize="10"
          fill={d.children ? null : "#ffffff"}
        >
          {d.dx <= 60 ? (
            <Fragment>
              {d.children ? null : `${getShortSymbol(d.name)} : ${d.size}% `}
            </Fragment>
          ) : (
            <Fragment>
              {d.children ? null : `${getShortSymbol(d.name)} : ${d.size}% `}
            </Fragment>
          )}
        </text>
        <title>{d.children ? null : `${d.name} : ${d.size}% `}</title>
      </g>
    );
  });
  return (
    <svg
      style={{ flex: 1, alignSelf: "stretch" }}
      viewBox={`0 0 ${width} ${height}`}
    >
      <g transform={`translate(${-0.5},${-0.5})`}>{cell}</g>
    </svg>
  );
};

TreeMap.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  data: PropTypes.shape({
    area: PropTypes.number,
    children: PropTypes.array,
    depth: PropTypes.number,
    dx: PropTypes.number,
    dy: PropTypes.number,
    name: PropTypes.string,
    value: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
  }).isRequired,
};
export default TreeMap;



// WEBPACK FOOTER //
// ./src/components/d3Components/treeMap/treeMap.js